export default __webpack_public_path__ + "static/media/graxalta_GxD_jpg_webdesign2021_productillustrations_hongos_01.3746b2d0.jpg";